function convertPillstoSlider() {
  document.querySelectorAll('.product-pills ul').forEach((slider) => {

    const items = slider.children;

    if (items.length <= 3) {
        return;
    }

    slider.classList.add('is-slider');

    let isDragging = false;
    let startX = 0;
    let startScroll = 0;

    slider.addEventListener('mousedown', (e) => {
        isDragging = true;
        slider.classList.add('dragging');

        startX = e.pageX;
        startScroll = slider.scrollLeft;
    });

    window.addEventListener('mouseup', () => {
        if (!isDragging) return;

        isDragging = false;
        slider.classList.remove('dragging');
        snapToNearest(slider);
    });

    slider.addEventListener('mouseleave', () => {
        if (!isDragging) return;

        isDragging = false;
        slider.classList.remove('dragging');
        snapToNearest(slider);
    });

    slider.addEventListener('mousemove', (e) => {
        if (!isDragging) return;

        e.preventDefault();

        const walk = (e.pageX - startX) * 1.5;
        slider.scrollLeft = startScroll - walk;
    });

    function snapToNearest(container) {
        const firstCard = container.children[0];
        if (!firstCard) return;

        const style = getComputedStyle(container);
        const gap = parseFloat(style.columnGap || style.gap) || 0;

        const itemWidth = firstCard.offsetWidth + gap;
        const index = Math.round(container.scrollLeft / itemWidth);

        container.scrollTo({
            left: index * itemWidth,
            behavior: 'smooth'
        });
    }

  });
}

document.addEventListener('DOMContentLoaded', () => {
  const quickBuyText = "Buy Now";

  const updateButtons = () => {
    document
      .querySelectorAll('.shopify-payment-button__button--unbranded')
      .forEach(btn => {
        if (btn.textContent.trim() === 'Buy it now') {
          btn.textContent = quickBuyText;
        }
      });
  };

  // Run once immediately
  updateButtons();

  // Observe future buttons (Ajax / Shopify render)
  const observer = new MutationObserver(() => {
    updateButtons();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

  convertPillstoSlider();
});


// $(document).ready(function () {
//   $(document).off('click', '.add-to-cart-btn').on('click', '.add-to-cart-btn', function () {
//     var ID = $(this).attr("data-variant");
//       addItemToCart( ID, 1);
//     });

//     function addItemToCart(variant_id, qty) {
//       data = {
//         "id": variant_id,
//         "quantity": qty
//       }
      
//       jQuery.ajax({
//         type: 'POST',
//         url: '/cart/add.js',
//         data: data,
//         dataType: 'json',
//         success: function() { 
//         document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
//             bubbles: true
//         }));

//         const cartDrawer = document.querySelector('cart-drawer');

//         setTimeout(() => {
//           if (cartDrawer) {
//             cartDrawer.setAttribute('open', '');
//           }
//         }, 500);
//       }  
//     }); 
//   }
// });


// $(document).ready(function () {
//   /* OPEN size guide */
//   $(document).on('click', '.size-guide', function (e) {
//     e.preventDefault();

//     $('.size-guide-drawer').addClass('active');
//     $('body').addClass('lock');
//     $('header').css('z-index', '2');
//   });

//   /* CLOSE on overlay click */
//   $(document).on('click', '.size-guide-drawer .size-chart-overlay', function () {
//     $('.size-guide-drawer').removeClass('active');
//     $('body').removeClass('lock');
//     $('header').css('z-index', '4');
//   });

//   /* CLOSE on SVG click (STOP bubbling) */
//   $(document).on('click', '.size-guide-drawer .drawer-content svg', function (e) {
//     e.stopPropagation();

//     $('.size-guide-drawer').removeClass('active');
//     $('body').removeClass('lock');
//     $('header').css('z-index', '4');
//   });
// });






// $(function () {

//     const $drawer = $('.size-guide-drawer');
//     const $body = $('body');

//     // store original position
//     const $originalParent = $drawer.parent();
//     const originalIndex = $drawer.index();

//     function openSizeGuide(e) {
//       e.preventDefault();

//       // move to body only once
//       if (!$drawer.data('moved')) {
//         $drawer.appendTo('body').data('moved', true);
//       }

//       $drawer.addClass('active');
//       $body.addClass('lock');
//     }

//     function closeSizeGuide() {
//       $drawer.removeClass('active');
//       $body.removeClass('lock');

//       // restore to original position
//       if ($drawer.data('moved')) {
//         if (originalIndex === 0) {
//           $drawer.prependTo($originalParent);
//         } else {
//           $drawer.insertAfter(
//             $originalParent.children().eq(originalIndex - 1)
//           );
//         }

//         $drawer.removeData('moved');
//       }
//     }

//     // OPEN
//     $(document).on('click', '.size-guide', openSizeGuide);

//     // CLOSE – overlay
//     $(document).on(
//       'click',
//       '.size-guide-drawer .size-chart-overlay',
//       closeSizeGuide
//     );

//     // CLOSE – SVG / close icon
//     $(document).on(
//       'click',
//       '.size-guide-drawer .drawer-content svg',
//       function (e) {
//         e.stopPropagation();
//         closeSizeGuide();
//       }
//     );

//   });






// $(function () {

//   const $drawer = $('.size-guide-drawer');
//   const $body = $('body');

//   const $originalParent = $drawer.parent();
//   const originalIndex = $drawer.index();

//   function openSizeGuide(e) {
//     e.preventDefault();

//     if (!$drawer.data('moved')) {
//       $drawer.appendTo('body').data('moved', true);
//     }

//     // 🔑 FORCE browser to register initial transform
//     $drawer[0].offsetHeight;

//     // NOW animate
//     $drawer.addClass('active');
//     $body.addClass('lock');
//   }

//   function closeSizeGuide() {
//     $drawer.removeClass('active');
//     $body.removeClass('lock');

//     if ($drawer.data('moved')) {
//       if (originalIndex === 0) {
//         $drawer.prependTo($originalParent);
//       } else {
//         $drawer.insertAfter($originalParent.children().eq(originalIndex - 1));
//       }
//       $drawer.removeData('moved');
//     }
//   }

//   $(document).on('click', '.size-guide', openSizeGuide);
//   $(document).on('click', '.size-guide-drawer .size-chart-overlay', closeSizeGuide);
//   $(document).on('click', '.size-guide-drawer .drawer-content svg', function (e) {
//     e.stopPropagation();
//     closeSizeGuide();
//   });

// });





$(function () {

  const $drawer = $('.size-guide-drawer');
  const $body = $('body');

  const $originalParent = $drawer.parent();
  const originalIndex = $drawer.index();

  let isClosing = false;

  function openSizeGuide(e) {
    e.preventDefault();

    if (!$drawer.data('moved')) {
      $drawer.appendTo('body').data('moved', true);
    }

    // force reflow
    $drawer[0].offsetHeight;

    $drawer.addClass('active');
    $body.addClass('lock');
  }

  function closeSizeGuide() {
    if (isClosing) return;
    isClosing = true;

    $drawer.removeClass('active');
    $body.removeClass('lock');

    // wait for slide-out animation
    $drawer.find('.drawer-content').one('transitionend', function () {

      if ($drawer.data('moved')) {
        if (originalIndex === 0) {
          $drawer.prependTo($originalParent);
        } else {
          $drawer.insertAfter(
            $originalParent.children().eq(originalIndex - 1)
          );
        }
        $drawer.removeData('moved');
      }

      isClosing = false;
    });
  }

  // OPEN
  $(document).on('click', '.size-guide', openSizeGuide);

  // CLOSE – overlay
  $(document).on(
    'click',
    '.size-guide-drawer .size-chart-overlay',
    closeSizeGuide
  );

  // CLOSE – close icon
  $(document).on(
    'click',
    '.size-guide-drawer .drawer-content svg',
    function (e) {
      e.stopPropagation();
      closeSizeGuide();
    }
  );

});



// $(document).on('click', 'footer a', function (e) {
//   if ($(this).text().trim().toLowerCase() === 'try at home') {
//     e.preventDefault();
//     $('[tab="tab-3"]').trigger('click');
//   }
// });


$(document).on('click', 'footer a', function (e) {
  if ($(this).text().trim().toLowerCase() === 'try at home') {
    e.preventDefault();

    const $tabTrigger = $('[tab="tab-3"]'); // tab button
    const $formBlock  = $('.try-at-home-form'); // form section

    // Step 1: Activate tab if exists
    if ($tabTrigger.length) {
      $tabTrigger.trigger('click');
    }

    // Step 2: Wait for form to be visible, then scroll
    // setTimeout(() => {
      if ($formBlock.length) {
        $('html, body').animate(
          {
            scrollTop: $formBlock.offset().top - 100 // adjust header height
          },
          600
        );
      }
    // }, 300); // delay allows tab content to render
  }
});



// document.addEventListener('click', function (e) {
//   const clearBtn = e.target.closest('a.facets-clear-all');
//   if (!clearBtn) return;

//   e.preventDefault();

//   const drawer = document.querySelector('facets-drawer[open]');
//   if (!drawer) return;

//   /* ✅ Trigger Dawn native clear */
//   clearBtn.click();

//   /* ✅ Close drawer immediately */
//   drawer.querySelector('dialog-close-button button')?.click();
// });


// // document.addEventListener('click', function (e) {
// //   const clearBtn = e.target.closest('a.facets-clear-all');
// //   if (!clearBtn) return;

// //   e.preventDefault();

// //   const drawer = document.querySelector('facets-drawer[open]');
// //   if (!drawer) return;

// //   /* 🔥 Let Dawn handle clearing via form submit */
// //   const form = drawer.querySelector('facets-form form');
// //   if (form) {
// //     form.reset();
// //     form.dispatchEvent(new Event('input', { bubbles: true }));
// //   }

// //   /* ✅ Close drawer */
// //   drawer.querySelector('dialog-close-button button')?.click();
// // });




// // document.addEventListener('change', function (event) {
// //   const input = event.target;

// //   // Only facet filter inputs inside drawer
// //   if (
// //     input.matches(
// //       'facets-form input[type="checkbox"], facets-form input[type="radio"]'
// //     )
// //   ) {
// //     const form = input.closest('facets-form');
// //     if (!form) return;

// //     // Debounce to avoid multiple Ajax calls
// //     clearTimeout(form._autoSubmitTimer);

// //     form._autoSubmitTimer = setTimeout(() => {
// //       form.dispatchEvent(
// //         new Event('submit', { bubbles: true, cancelable: true })
// //       );
// //     }, 150);
// //   }
// // });


// // document.addEventListener('DOMContentLoaded', () => {
// //   const drawer = document.querySelector('facet-drawer');
// //   if (!drawer) return;

// //   // Avoid duplicate button
// //   if (drawer.querySelector('.facet-clear-all')) return;

// //   const clearBtn = document.createElement('button');
// //   clearBtn.type = 'button';
// //   clearBtn.className = 'facet-clear-all';
// //   clearBtn.textContent = 'Clear all';

// //   // Insert at top of drawer content
// //   const container = drawer.querySelector('.facet-drawer__inner, .facet-drawer__content');
// //   if (container) {
// //     container.prepend(clearBtn);
// //   }

// //   clearBtn.addEventListener('click', () => {
// //     const form = drawer.querySelector('facets-form');
// //     if (!form) return;

// //     // Reset inputs
// //     form.querySelectorAll('input').forEach(input => {
// //       if (input.type === 'checkbox' || input.type === 'radio') {
// //         input.checked = false;
// //       }

// //       if (input.type === 'number') {
// //         input.value = '';
// //       }
// //     });

// //     // Trigger Prestige Ajax refresh
// //     form.dispatchEvent(
// //       new Event('submit', { bubbles: true, cancelable: true })
// //     );
// //   });
// // });




// // document.addEventListener('DOMContentLoaded', () => {
// //   const drawer = document.querySelector('facets-drawer');
// //   if (!drawer) return;

// //   // Prevent duplicate button
// //   if (drawer.querySelector('.facet-clear-all')) return;

// //   const clearBtn = document.createElement('button');
// //   clearBtn.type = 'button';
// //   clearBtn.className = 'facet-clear-all';
// //   clearBtn.textContent = 'Clear all filters';

// //   // Insert button BELOW "Filters" heading
// //   const header = drawer.querySelector('[slot="header"]');
// //   if (header) {
// //     header.insertAdjacentElement('afterend', clearBtn);
// //   }

// //   clearBtn.addEventListener('click', () => {
// //     const form = drawer.querySelector('facets-form form');
// //     if (!form) return;

// //     // Reset all filter inputs
// //     form.querySelectorAll('input').forEach(input => {
// //       if (input.type === 'checkbox' || input.type === 'radio') {
// //         input.checked = false;
// //       }

// //       if (input.type === 'number') {
// //         input.value = '';
// //       }
// //     });

// //     // 🔥 Trigger Prestige Ajax refresh
// //     form.dispatchEvent(
// //       new Event('submit', { bubbles: true, cancelable: true })
// //     );
// //   });
// // });




// (function () {
//   let keepDrawerOpen = false;
//   let lastInteractionTime = 0;
//   let reopenScheduled = false;

//   /* ===============================
//      AUTO APPLY (checkbox / radio)
//   ================================ */
//   document.addEventListener('change', function (event) {
//     const input = event.target;

//     if (
//       input.matches(
//         'facets-form input[type="checkbox"], facets-form input[type="radio"]'
//       )
//     ) {
//       const facetsForm = input.closest('facets-form');
//       if (!facetsForm) return;

//       const form = facetsForm.querySelector('form.facets');
//       if (!form) return;

//       keepDrawerOpen = true;
//       lastInteractionTime = Date.now();

//       clearTimeout(form._autoSubmitTimer);
//       form._autoSubmitTimer = setTimeout(() => {
//         form.requestSubmit();
//       }, 150);
//     }
//   });

//   /* ===============================
//      PRICE RANGE AUTO APPLY
//   ================================ */
//   document.addEventListener('input', function (event) {
//     if (!event.target.closest('price-range')) return;

//     const facetsForm = event.target.closest('facets-form');
//     if (!facetsForm) return;

//     const form = facetsForm.querySelector('form.facets');
//     if (!form) return;

//     keepDrawerOpen = true;
//     lastInteractionTime = Date.now();

//     clearTimeout(form._priceTimer);
//     form._priceTimer = setTimeout(() => {
//       form.requestSubmit();
//     }, 500);
//   });

//   /* ===============================
//      MUTATION OBSERVER (NO FLICKER)
//   ================================ */
//   const observer = new MutationObserver(() => {
//     if (!keepDrawerOpen) return;

//     // stop reopening after interaction ends
//     if (Date.now() - lastInteractionTime > 700) {
//       keepDrawerOpen = false;
//       return;
//     }

//     // 🔒 prevent repeated reopen in same frame
//     if (reopenScheduled) return;
//     reopenScheduled = true;

//     requestAnimationFrame(() => {
//       reopenScheduled = false;

//       const drawers = document.querySelectorAll('facets-drawer');
//       if (!drawers.length) return;

//       // remove duplicates
//       drawers.forEach((drawer, i) => {
//         if (i < drawers.length - 1) drawer.remove();
//       });

//       const drawer = drawers[drawers.length - 1];

//       drawer.setAttribute('open', '');
//       drawer.style.display = 'block';
//     });
//   });

//   observer.observe(document.body, {
//     childList: true,
//     subtree: true
//   });

//   /* ===============================
//      REMOVE PRESTIGE FOCUS LOCK
//   ================================ */
//   function removeFocusLock() {
//     document.querySelectorAll('body > div[id]').forEach(div => {
//       if (div.style?.zIndex === '2147483647') {
//         div.remove();
//       }
//     });
//   }

//   /* ===============================
//      RESET ON MANUAL CLOSE
//   ================================ */
//   document.addEventListener('click', function (event) {
//     if (
//       event.target.closest('[data-drawer-close]') ||
//       event.target.matches('.drawer-overlay')
//     ) {
//       keepDrawerOpen = false;

//       setTimeout(removeFocusLock, 50);
//     }
//   });

// })();